module.exports = __webpack_public_path__ + "static/img/products.2798545.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/products.jpg
// module id = /2ja
// module chunks = 1